import React from "react";
import Image from "next/image";
import { isJSXElement } from "@utils/common";

export interface SummaryItemProps {
    title: string | JSX.Element;
    description: string | JSX.Element;
}

export interface PageSummaryProps {
    mainTitle?: string;
    mainDescription?: string;
    imgUrl?: string;
    imgAlt?: string;
    buttonText?: string;
    link?: string;
    summaryItem: SummaryItemProps[];
}

const PageSummaryV2: React.FC<PageSummaryProps> = (props) => {
    const { mainTitle, mainDescription, imgUrl, imgAlt, link, buttonText, summaryItem } = props;

    return (
        <div className="lg:max-w-6xl lg:mx-auto">
            <div className="lg:max-w-6xl mx-auto lg:px-0 px-3">
                {mainTitle && <h2 className="lg:text-4xl text-2xl text-center text-gray-700 font-bold lg:pb-6 pb-2">{mainTitle}</h2>}
                {mainDescription && <p className="text-base text-center text-gray-500 font-normal">{mainDescription}</p>}
            </div>

            <div className="flex lg:flex-row flex-col-reverse justify-center gap-8 lg:px-0 px-3 pt-10">
                {imgUrl && <Image src={imgUrl} alt={imgAlt ?? ""} width={585} height={540} className="lg:w-1/2 w-full" />}
                <div className="flex flex-col lg:w-1/2 w-full lg:items-start items-center">
                    {summaryItem.map((item, index) => {
                        const { title, description } = item;
                        return (
                            <div key={index}>
                                {isJSXElement(title) ? (
                                    title
                                ) : (
                                    <h2 className="lg:text-xl text-base lg:text-left text-center text-gray-600 lg:font-medium font-bold pb-1">{title}</h2>
                                )}
                                {isJSXElement(description) ? description : <p className="text-base lg:text-left text-center text-gray-500 pb-4">{description}</p>}
                            </div>
                        );
                    })}

                    {buttonText && link && (
                        <a href={link} className="text-white hover:no-underline bg-blue-500 hover:bg-blue-600 px-4 py-2 mt-5 w-fit rounded-md" rel="noreferrer" target="_blank">
                            {buttonText}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PageSummaryV2;
